import * as THREE from 'three';
import { SceneNode } from '../core/SceneNode';

export abstract class EnvironmentSystemBase extends SceneNode {
    public enabled: boolean = true;
    protected group: THREE.Group;

    constructor(name: string) {
        super(name);
        this.group = new THREE.Group();
        this.group.name = name;
        this._mesh = this.group;
    }

    initialize(): void {
        this.build();
    }

    dispose(): void {
        // subclasses override to clean up
    }

    setEnabled(value: boolean): void {
        this.enabled = value;
        if (this.group) this.group.visible = value;
    }

    protected abstract build(): void;

    // Provide a conservative bounding box so abstract requirement is satisfied
    protected calculateBoundingBox(): THREE.Box3 {
        const box = new THREE.Box3();
        if (this._mesh) {
            box.setFromObject(this._mesh);
        }
        // Fallback to a small box around origin if empty
        if (box.isEmpty()) {
            box.setFromCenterAndSize(new THREE.Vector3(0, 0, 0), new THREE.Vector3(1, 1, 1));
        }
        return box;
    }
}
